<template>
    <div class="side-panel">
        <div class="header-wrapper">
            <div class="header-wrapper-inner">
                <pendo-button
                    ref="closeButton"
                    theme="app"
                    icon="x"
                    icon-size="20"
                    type="tertiary"
                    class="close-icon"
                    @click="closeSidePanel" />
                <div class="header-slot-wrapper">
                    <slot
                        name="header"
                        class="header-slot" />
                </div>
            </div>
        </div>
        <slot
            name="body"
            style="height: 100%" />
    </div>
</template>

<script>
import { PendoButton } from '@pendo/components-vue3';
import { EventBus } from '@utils/event-bus.js';
import { getFirstFocusableNode } from '@/utils/dom.utils';

export default {
    name: 'SidePanel',
    components: {
        PendoButton,
    },
    created () {
        EventBus.$on('focusSidePanel', this.focusPanel);
    },
    beforeUnmount () {
        EventBus.$off('focusSidePanel', this.focusPanel);
    },
    methods: {
        focusPanel () {
            const node = this.$el && getFirstFocusableNode(this.$el);
            if (node) {
                node.focus();
            } else {
                const btn = this.$refs.closeButton;
                const btnEl = btn?.$el ?? btn;
                const focusableInBtn = btnEl && getFirstFocusableNode(btnEl);
                if (focusableInBtn) {
                    focusableInBtn.focus();
                }
            }
        },
        closeSidePanel () {
            EventBus.$emit('sidePanelClosed');
        },
    },
};
</script>

<style lang="less" scoped>
.side-panel {
    width: 100%;
    height: 100%;
    border-left: solid 1px var(--palette-gray-40);
    overflow: hidden;
    display: flex;
    flex-direction: column;
    position: relative;

    .header-wrapper {
        padding: 20px 16px;

        .header-slot-wrapper {
            flex: 1 1 auto;
            word-wrap: break-word;
        }

        .close-icon {
            color: var(--palette-gray-60);
            height: 24px;
            width: 24px;
            float: right;

            &:hover {
                color: var(--palette-gray-70);
            }
        }
    }
}
</style>
